// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st0,.st2{stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke:#00bdf0}.st0{fill:none}.st1{fill:#fff}.st2{fill:#00bdf0}", ""]);
// Exports
module.exports = exports;
